/** 
 * 商品权益
 */
import { useEffect, useState } from 'react'
import { apiGoodsRightsTemp } from "services/api";
import { useRequest } from "hooks";
import { getArrByCode } from "utils/utils"
import PropTypes from "prop-types";

const useRights = (props) => {
  const { goodsId, curRights, rightsTempData } = props
  // 权益模板
  const [rightsTemp, setRightsTemp] = useState(rightsTempData || [])
  // 选中权益
  const [rowKeys, setRowKeys] = useState([])
  // 当前权益
  const [rights, setRights] = useState(curRights || [])
  const [getRightsTemp] = useRequest({
    ...apiGoodsRightsTemp,
    onSuccess: (res) => {
      // console.log('onSuccess getRightsTemp', res);
      setRightsTemp(res?.data || [])
    },
  });

  useEffect(() => {
    if (!props?.hasOwnProperty('rightsTempData')) {
      // console.log('goodsId',goodsId);
      getRightsTemp({ goodsId })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])


  useEffect(() => {
    const arr = getArrByCode('rightsId', rights || []);
    setRowKeys(arr);
  }, [rights]);

  return {
    rightsTemp,
    rowKeys,
    setRights
  }
}

useRights.propTypes = {
  /** 商品id */
  goodsId: PropTypes.string.isRequired,
  /** 当前权益数据 */
  curRights: PropTypes.array,
  /** 权益模板数据 */
  rightsTempData: PropTypes.array
};

export default useRights